import { render, staticRenderFns } from "./Accesses.vue?vue&type=template&id=0a6b7042&scoped=true&lang=pug&"
import script from "./Accesses.vue?vue&type=script&lang=ts&"
export * from "./Accesses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b7042",
  null
  
)

export default component.exports